<template>
  <div class="ticket-toolbar border-top border-bottom">
    <loading-screen :is-loading="isSaving"></loading-screen>
    <div class="container-fluid px-3 d-flex">

      <!-- Left -->
      <div class="flex-grow-1">
        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="toggleWatching" :disabled="isTogglingWatching">
            <i class="fa" :class="{ 'fa-eye': isWatching, 'fa-eye-slash': !isWatching }" v-if="!isTogglingWatching"></i>
            <b-spinner small v-if="isTogglingWatching"></b-spinner>
          </button>
        </div>
        <div class="btn-group mr-2">
          <!-- <button type="button" class="btn btn-itg" @click="selectAction('reply')">
            <i class="fa fa-reply mr-1"></i> Reply
          </button> -->
          <button type="button" class="btn btn-itg" @click="selectAction('add-note')">
            <i class="fa fa-pencil-alt mr-1"></i> Add note
          </button>
          <button type="button" class="btn btn-itg" @click="selectAction('forward-ticket')">
            <i class="fa fa-reply fa-flip-horizontal mr-1"></i> Forward
          </button>
        </div>
        <!-- <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="selectAction('send-sms')">
            <i class="fa fa-comment-dots mr-1"></i> SMS
          </button>
        </div> -->
        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="selectAction('send-whatsapp')">
            <i class="fab fa-whatsapp  mr-1"></i> WhatsApp
          </button>
        </div>
        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="attemptCloseTicket">
            <i class="fa fa-check-circle mr-1"></i> Close
          </button>
        </div>
        <!--            <div class="btn-group mr-2">-->
        <!--                <button type="button" class="btn btn-itg">-->
        <!--                    <i class="fa fa-copy mr-1"></i> Merge-->
        <!--                </button>-->
        <!--            </div>-->
        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="openSplitTicketModal">
            <i class="fa fa-cut mr-1"></i> Split
          </button>
          <button type="button" class="btn btn-itg" @click="openMergeTicketModal">
            <i class="fa fa-object-group mr-1"></i> Merge
          </button>
        </div>

        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="attemptDelete">
            <i class="fa fa-trash mr-1"></i> Delete
          </button>
        </div>

        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click="openEditTicketDetailsModal">
            <i class="fa fa-info-circle mr-1"></i> Edit
          </button>
        </div>
        <edit-ticket-details-modal></edit-ticket-details-modal>

        <div class="btn-group mr-2">
          <button type="button" class="btn btn-itg" @click.prevent="openSendToTcModal">
            <i class="fa fa-reply fa-flip-horizontal mr-1"></i> Send to TC
          </button>
        </div>
        <send-to-tc-modal ref="send-to-tc-modal"></send-to-tc-modal>
        <split-ticket-modal></split-ticket-modal>
        <merge-ticket-modal></merge-ticket-modal>
        <!--            <div class="btn-group mr-2">-->
        <!--                <button type="button" class="btn btn-itg">-->
        <!--                    <i class="fa fa-clock mr-1"></i> Show activities-->
        <!--                </button>-->
        <!--            </div>-->
      </div>
      <!-- / Left -->
      <!-- Right -->
      <div>
        <div class="btn-group">
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'incident-report' }"
            v-b-tooltip.hover.bottom title="Incident Report" @click="setSidebarSection('incident-report')">
            <i class="fa fa-exclamation-triangle"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'contacts' }"
            v-b-tooltip.hover.bottom title="Contacts" @click="setSidebarSection('contacts')">
            <i class="fa fa-user"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'tasks' }"
            v-b-tooltip.hover.bottom title="Tasks" @click="setSidebarSection('tasks')">
            <i class="fa fa-list"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'media' }"
            @click="setSidebarSection('media')" v-b-tooltip.hover.bottom
            :title="`Media ${(media && media.length) ? '(' + media.length + ')' : ''}`">
            <i class="fa fa-file ml-1 mr-1"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'axum' }"
            @click="setSidebarSection('axum')" v-b-tooltip.hover.bottom title="Axum">
            <i class="fa fa-info ml-1 mr-1"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'related-tickets' }"
            v-b-tooltip.hover.bottom title="Related Tickets" @click="setSidebarSection('related-tickets')">
            <i class="fa fa-link"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'audit' }"
            v-b-tooltip.hover.bottom title="Audit" @click="setSidebarSection('audit')">
            <i class="fa fa-clock"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'office-transfers' }"
            v-b-tooltip.hover.bottom title="Office Transfer" @click="setSidebarSection('office-transfers')">
            <i class="fa fa-recycle"></i>
          </button>
          <button type="button" class="btn btn-itg text-center" :class="{ 'active': sidebarSection === 'bookmarks' }"
            v-b-tooltip.hover.bottom title="Bookmarks" @click="setSidebarSection('bookmarks')">
            <i class="fa fa-heart"></i>
          </button>
          <button type="button" class="btn btn-itg" :class="{ 'active': sidebarSection === 'expenses' }"
            v-b-tooltip.hover.bottom title="Expenses" @click="setSidebarSection('expenses')">
            <i class="fa fa-dollar-sign mr-1 ml-1"></i>
          </button>
        </div>
      </div>
      <!-- / Right -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import Forms from "../../../../mixins/Forms";
import Tickets from "../../../../mixins/Tickets";
import EditTicketDetailsModal from "./TicketToolbar/EditTicketDetailsModal";
import SendToTcModal from './widgets/SendToTcModal.vue';
import SplitTicketModal from './TicketToolbar/SplitTicketModal.vue';
import MergeTicketModal from './TicketToolbar/MergeTicketModal.vue';

export default {
  name: "TicketToolbar",
  data() {
    return {
      isSaving: false,
      isTogglingWatching: false,
      isWatching: null
    }
  },
  components: { EditTicketDetailsModal, SendToTcModal, SplitTicketModal, MergeTicketModal },
  mixins: [Forms, Tickets],
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      media: 'media',
      sidebarSection: 'sidebarSection'
    })
  },
  created() {
    // this.isWatching = _.map(this.ticket.watchers, 'email').includes(this.$auth.user.email);
    this.isWatching = _.map(this.ticket.watchers, 'email').includes(this.$auth.user.username);
  },
  methods: {
    ...mapActions('ticketViewer', {
      selectAction: 'selectAction',
      setSidebarSection: 'setSidebarSection'
    }),

    attemptDelete() {
      if (this.isSaving) {
        return false;
      }

      let vm = this;
      swal({
        title: "Are you sure you want to delete this ticket?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {

          swal({
            title: "Are you REALLY sure you want to delete this ticket?",
            text: "This cannot be undone.",
            icon: "warning",
            buttons: {
              cancel: true,
              confirm: "Delete"
            },
            dangerMode: true,
          }).then((sureShouldDelete) => {
            if (sureShouldDelete) {
              vm.delete();
            }
          });

        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios.delete(API_BASE + '/tickets/' + this.ticket.id).then(r => {
        vm.isSaving = false;
        this.$notify.success({
          title: 'Success!',
          message: 'Ticket deleted successfully'
        });
        this.$router.push('/tickets');
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    },

    attemptCloseTicket() {
      if (this.isSaving) {
        return false;
      }

      // Number of incomplete tasks
      let incompleteTasks = _.filter(this.ticket.tasks, t => !t.completed_at).length;

      let text = 'Close Ticket';
      if (incompleteTasks > 0) {
        text = 'Close Ticket (Warning: ' + incompleteTasks + ' Incomplete Tasks!)';
      }

      let vm = this;
      swal({
        text: text,
        icon: 'warning',
        dangerMode: true,
        content: {
          element: "input",
          attributes: {
            type: 'text',
            placeholder: 'Enter closing note here...'
          }
        },
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: "Cancel",
            visible: true,
          },
          confirm: {
            text: "Close Ticket",
          }
        }
      }).then((val) => {
        if (val) {
          vm.closeTicket(val);
        }
      });

      // swal({
      //     title: "Are you sure you want to close this ticket?",
      //     icon: "warning",
      //     buttons: {
      //         cancel: true,
      //         confirm: "Close Ticket"
      //     },
      //     dangerMode: true,
      // }).then((shouldCloseTicket) => {
      //     if (shouldCloseTicket) {
      //         vm.closeTicket();
      //     }
      // });
    },

    closeTicket(closingNote) {
      let vm = this;
      vm.isSaving = true;
      axios.put(API_BASE + '/tickets/' + this.ticket.id, {
        status: vm.getTicketStatusCodeFromHumanReadable('Closed'),
        closing_note: closingNote
      }).then(r => {
        vm.isSaving = false;
        this.$notify.success({
          title: 'Success!',
          message: 'Ticket closed successfully'
        });
        this.$router.push('/tickets');
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    },

    toggleWatching() {
      if (this.isSaving || this.isTogglingWatching) {
        return false;
      }

      let vm = this;
      vm.isTogglingWatching = true;
      axios.post(API_BASE + '/tickets/' + this.ticket.id + '/watchers/toggle').then(r => {
        vm.isTogglingWatching = false;
        vm.isWatching = !vm.isWatching;
        if (this.isWatching) {
          this.$notify.success({
            title: 'Success!',
            message: 'You are now watching this ticket'
          });
        } else {
          this.$notify.success({
            title: 'Success!',
            message: 'You are no longer watching this ticket'
          });
        }
      }).catch(e => {
        vm.isTogglingWatching = false;
        console.log(e);
        vm.notifyErrors(e);
      });
    },

    openEditTicketDetailsModal() {
      this.$bvModal.show('edit-ticket-details-modal');
    },

    openSendToTcModal() {
      this.$bvModal.show('send-to-tc-modal');
      this.$refs['send-to-tc-modal'].attemptPopulateTravelConsultant();
    },

    openSplitTicketModal() {
      this.$bvModal.show('split-ticket-modal');
    },

    openMergeTicketModal() {
      this.$bvModal.show('merge-ticket-modal');
    }
  }
}
</script>

<style scoped>
.ticket-toolbar {
  border-top: 1px #ebeff3 solid !important;
  border-bottom: 1px #cfd7df solid !important;
  padding-top: 11px;
  padding-bottom: 11px;
  box-shadow: 0 2px 4px 0 rgba(24, 50, 71, .08);
  z-index: 1;
}
</style>
